<template>
	<div class="publishers">
		<pages-publishers-intro />
		<pages-publishers-howto />
		<pages-publishers-advantages />
		<pages-publishers-formats />
		<SectionPartners :partners="publishersPartners" />
		<BlocksPublishersModal v-model:is-modal-open="publisherModal.isOpen" />
	</div>
</template>

<script setup lang="ts">
	import { PUBLISHERS_PARTNERS } from '~/constants/partners'

	const publishersPartners = PUBLISHERS_PARTNERS
	const { $ScrollTrigger: ScrollTrigger } = useNuxtApp()

	const publisherModal = usePublisherModal()

useHead({
	link: [
		{
			rel: 'preload',
			as: 'image',
			href: '/images/pages/publishers/intro-frame.jpg',
			fetchpriority: 'high',
		},
	],
})

	onMounted(() => {
	if (import.meta.client) {
		window.scrollTo({ top: 0, behavior: 'instant' })
	}
		ScrollTrigger.refresh()
	})
</script>

<!-- <script setup lang="ts">

</script>

<style scoped>

</style> -->
